import React, { ReactNode, useState } from 'react'
import isEmpty from 'lodash/isEmpty'
import styles from '../../DrawerGQL/Drawer.module.scss'
import { ISpace } from '@api'
import { Divider } from '@runeffective/evo-design-system'
import BookingsAccordion from './components/BookingsAccordion'
import { UseFloorHook } from '@providers/mapProvider'

export const DrawerBookingsList = ({
  spaces,
  children,
  open,
  floor,
}: {
  spaces: ISpace[]
  children: ReactNode
  open: boolean
  floor: UseFloorHook
}) => {
  const hasBookings = Object.keys(spaces).some((key) => {
    const space = spaces[key as unknown as number]
    return space && space.bookings && space.bookings.length > 0
  })

  return (
    <div style={{ width: open ? 320 : 34 }} className={styles.drawer}>
      <div className={styles.dividerWrapper}>
        <span className={styles.divider}>
          <Divider type="vertical"></Divider>
        </span>
      </div>
      {children}

      {hasBookings ? (
        open && <BookingsAccordion spaces={spaces} floor={floor} />
      ) : (
        <div className={styles.drawer_empty_state}>
          <i className="far fa-clock" aria-hidden="true" />
          <p>At these dates/times, no one has booked a desk.</p>
        </div>
      )}
    </div>
  )
}

export default DrawerBookingsList
